import { useQuery, UseQueryOptionsLux } from '@gemini/lux-ds-pms';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { useMemo } from 'react';
// useQuery wrapper
export function useOBQuery<T>(
  url: string | undefined,
  options?: Omit<UseQueryOptionsLux<T>, 'queryFn'>,
) {
  const brandName = useOnlineBookingStore(state => state.brandName);
  const jwtToken = useOnlineBookingStore(state => state.jwtToken);
  const headers: Record<string, string> = useMemo(
    () => ({
      ...(options?.headers || {}),
      ...(jwtToken && { 'x-user-context': jwtToken }),
      ...(brandName && { 'x-brand-code': brandName }),
    }),
    [options?.headers, jwtToken, brandName],
  );

  const newOptions = useMemo(
    () => ({
      ...options,
      headers,
      autoRefreshToken: false,
    }),
    [options, headers],
  );

  return useQuery<T>(url, newOptions);
}
